import request from "@/utils/request";

const api = {
  MaterialPageQuery: "material/pageList",
  SoftDelete:"/material/softDelete",
  Regain:"/material/regain",
  Save:"/material/saveOrUpdate",
  Rename:"/material/rename",
  GetFolderDepth:"/material/getParentInfo",

  QuerySub:"/material/getAllDir",
  MoveDir:"/material/moveDir",
  Recycle:"/material/recycle",
  Delete:"/material/delete",
  MaterialAdd:"/material/add"
};

export default api;

export function materialPageQuery(data) {
  return request({
    url: api.MaterialPageQuery,
    method: "post",
    data,
  });
}

export function softDelete(data) {
  return request({
    url: api.SoftDelete,
    method: "post",
    data,
  });
}

export function regain(data) {
  return request({
    url: api.Regain,
    method: "post",
    data,
  });
}

export function save(data) {
  return request({
    url: api.Save,
    method: "post",
    data,
  });
}

export function rename(data) {
  return request({
    url: api.Rename,
    method: "post",
    data,
  });
}
export function getFolderDepth(data){
  return request({
    url: api.GetFolderDepth,
    method: "post",
    data,
  });
}
export function querySub(data){
  return request({
    url: api.QuerySub,
    method: "post",
    data,
  });
}

export function moveDir(data){
  return request({
    url: api.MoveDir,
    method: "post",
    data,
  });
}

export function recycle(data){
  return request({
    url: api.Recycle,
    method: "post",
    data,
  });
}

export function materialDelete(data){
  return request({
    url: api.Delete,
    method: "post",
    data,
  });
}

export function materialAdd(data){
  return request({
    url: api.MaterialAdd,
    method: "post",
    data,
  });
}